import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import HelpCenterLink from 'modules/core/components/HelpCenterLink'
import i18n from 'modules/core/lib/i18n'

const AuditTrailContent = () => {
  return (
    <>
      <Box gap="s8">
        <Text.Normal>{i18n.t('documents.modal.audit_trail.modal.description')}</Text.Normal>
      </Box>
      <Box paddingTop="s24" gap="s8">
        <HelpCenterLink name="esignature">
          {i18n.t('documents.modal.audit_trail.modal.help_center')}
        </HelpCenterLink>
      </Box>
    </>
  )
}

export default AuditTrailContent
